import { QRCodeSVG } from '@rc-component/qrcode'
import { Button, IconButton } from 'component/Button'
import { Link } from 'component/Link'
import { Modal } from 'component/Modal'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { boutiqueQrModal } from 'page/catalog/store/BoutiqueQrModalStore'
import { demo } from 'page/catalog/store/CatalogStore'
import { ui } from 'store/home/ui/HomeUiStore'
import { copyText } from 'util/browser'

function getOutfitsUrl() {
  const { slug } = demo.it
  const { widget_user_id } = boutiqueQrModal.it
  const origin = location.origin
  return `${origin}/outfits/${widget_user_id}/${slug}`
}

export const BoutiqueQrModal = observer(() => {
  const { width, height } = ui.window
  const size = Math.min(width - 64 - 40, height - 64, 240)
  const url = getOutfitsUrl()

  const onClose = useLatestCallback(() => {
    boutiqueQrModal.close()
  })

  const onCopy = useLatestCallback(() => {
    void copyText(url)
    boutiqueQrModal.close()
  })

  return (
    <Modal open={true} white title={' '} width={400} onCancel={onClose}>
      <Vertical gap={16} center>
        <Typo size={11} upper>
          {i18n('ScanQrCodeWithCustomerTablet')}
        </Typo>

        <Space pad={20}>
          <QRCodeSVG value={url} size={size} />
        </Space>

        <Space gap={16} maxWidth={240} oh wide center>
          <Space height={40} flex="1 1 0" />
          <Space oh>
            <Link href={url} action={onClose}>
              <Button xl>{i18n('OpenLink')}</Button>
            </Link>
          </Space>
          <Space height={40} flex="1 1 0" right>
            <IconButton tertiary large action={onCopy}>
              <Icon size={16} name="content_copy" />
            </IconButton>
          </Space>
        </Space>
      </Vertical>
    </Modal>
  )
})
